import { useQuery } from '@tanstack/react-query';
import { locationsApi } from '../../settings/locations/api/locationsApi';
import { LocationFilterParams } from '../../settings/locations/types/location.types';

export const useLocations = (params?: LocationFilterParams) => {
  const {
    data: locationsResponse,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['locations', params],
    queryFn: () => locationsApi.getAll(params || {}),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    locations: locationsResponse?.data || [],
    total: locationsResponse?.total || 0,
    isLoading,
    error,
    refetch
  };
};
